import { render, staticRenderFns } from "./customerOfInternet.vue?vue&type=template&id=234c4b7d&scoped=true&"
import script from "./customerOfInternet.vue?vue&type=script&lang=js&"
export * from "./customerOfInternet.vue?vue&type=script&lang=js&"
import style0 from "./customerOfInternet.vue?vue&type=style&index=0&id=234c4b7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c4b7d",
  null
  
)

export default component.exports